import { useEffect, useState } from 'react';
import { Table, Input, FormGroup } from 'reactstrap';

const Points = ({ user, usersPoints, setUserPoints }) => {
    const [isRodzinka, setIsRodzinka] = useState(usersPoints[user.name].rodzinka.value > 0);

    const updateState = (name, value) => {
        const newPoints = { ...usersPoints[user.name][name] }
        if (newPoints) {
            newPoints.value = value;
        }

        // Check if rodzinka should have points
        let shouldRodzinka = true;
        Object.values(usersPoints[user.name]).forEach((data) => {
            if (data.value <= 0) {
                shouldRodzinka = false;
            }
        });

        const newState = { ...usersPoints, [user.name]: { ...usersPoints[user.name], [name]: newPoints } };

        setUserPoints({ ...newState })
    }

    useEffect(() => {
        isRodzinka ? updateState('rodzinka', 10) : updateState('rodzinka', 0)
    }, [isRodzinka])

    return (
        <Table bordered className='mt-3 text-center'>
            <thead>
                <tr>
                    <th>
                        typ
                    </th>
                    <th>
                        punkty
                    </th>
                </tr>
            </thead>
            <tbody>
                {usersPoints[user.name] && Object.entries(usersPoints[user.name]).map(([key, data]) => (
                    <tr key={key}>
                        <td>{data.name}</td>
                        <td>
                            {key !== 'rodzinka' && <Input type='number' className='text-center' min="0" step="1" value={data.value} name={key} onChange={(e) => { updateState(key, Number(e.target.value)) }} />}
                            {key === 'rodzinka' && <div className='d-flex justify-content-center'>
                                <FormGroup switch>
                                    <Input defaultChecked={isRodzinka} type="switch" name={key} onClick={(e) => { setIsRodzinka(!isRodzinka); }} />
                                </FormGroup>
                            </div>}
                        </td>
                    </tr>
                ))}
                <tr key='summary'>
                    <td>Podsumowanie</td>
                    <td>
                        {Object.values(usersPoints[user.name]).reduce((acc, data) => {
                            if (data.value > 0) {
                                acc += data.value;
                            }
                            return acc;
                        }, 0)}
                    </td>
                </tr>
            </tbody>
        </Table>
    )
}

export default Points;